import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { createProduct } from "../../actions/productAction";
import Axios from "../../axios/axios";
import { ListCategories } from "../../actions/categoryAction";
import Stock from "./Stock";
import imageCompression from "browser-image-compression";
import { ListCategorieswithoutpagination } from "../../actions/categoryAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateProduct = () => {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [photo1, setPhoto1] = useState("");
  const [photo2, setPhoto2] = useState("");
  const [photo3, setPhoto3] = useState("");
  const [brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [service, setService] = useState("");
  const [warrantyType, setWarrantyType] = useState();
  const [productType, setProductType] = useState("");
  const [billUpload, setBillUpload] = useState("");

  const [stock, setStock] = useState([
    {
      stock: 1,
      itemCode: "",
      serialNumber: "",
      qrCode: "",
    },
  ]);
  const [brandList, setBrandList] = useState([]);
  const [loader, setLoader] = useState(false);

  const catList = useSelector((state) => state.catList);
  const { loading, error, categories } = catList;

  const prodCreate_ = useSelector((state) => state.productCreate);
  const { error: prodCreateError, success: prodCreateSuccess } = prodCreate_;

  // Redirect on success
  useEffect(() => {
    if (prodCreateSuccess === true) {
      window.location.href = "/products";
    }
  }, [prodCreateSuccess]);

  // Show toast on error
  useEffect(() => {
    if (prodCreateError) {
      toast.error(prodCreateError); // <-- This will show the error as a toast
    }
  }, [prodCreateError]);

  useEffect(() => {
    dispatch(ListCategorieswithoutpagination());
    getBrands();
  }, [dispatch]);

  const getBrands = async () => {
    try {
      const brandRes = await Axios.get("/api/brand?pageSize=1000&pageNumber=1");
      setBrandList(brandRes.data.brands);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  useEffect(() => {
    if (prodCreateSuccess === true) {
      window.location.href = "/products";
    }
  }, [prodCreateSuccess]);

  const submitHandler = (e) => {
    e.preventDefault();
    setLoader(true);

    dispatch(
      createProduct({
        name,
        description,
        category,
        image1: photo1,
        image2: photo2,
        image3: photo3,
        brand,
        price,
        offerPrice,
        itemCode,
        stock,
        productType: productType === "true",
      })
    );
  };

  const uploadFileHandler = async (e, val) => {
    console.log("uploading");
    const file = e.target.files[0];

    // Set up image compression options
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);
      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await Axios.post("/api/upload", formData, config);

      if (val === "photo1") {
        setPhoto1(data);
      } else if (val === "photo2") {
        setPhoto2(data);
      } else if (val === "photo3") {
        setPhoto3(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const [errors, setErrors] = useState({});
  const addStock = () => {
    let newItemCode = ""; // You can generate or input a new item code here

    // Check if itemCode is unique
    if (stock.some((item) => item.itemCode === newItemCode)) {
      alert("Item code must be unique");
      return;
    }

    let obj = {
      stock: 1,
      itemCode: "",
      serialNumber: "",
      qrCode: "",
    };

    setStock([...stock, obj]);
  };

  console.log(stock);

  const updateError = (index, errorMessage) => {
    const newErrors = { ...errors, [index]: errorMessage };
    setErrors(newErrors);
  };

  let stockDiv = stock.map((data, index) => {
    return (
      <Stock
        index={index}
        setStock={setStock}
        stock={stock}
        product={{ name, price, offerPrice, brand, category }}
        brandList={brandList}
        categories={categories}
        errors={errors}
        updateError={updateError}
      />
    );
  });

  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Create Product</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">Product Name</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  required={true}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Description</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Category</label>
                <select
                  className="form-control"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required={true}
                >
                  <option value="">Select Category</option>
                  {categories?.map((data) => (
                    <option value={data?._id}>{data?.categoryName}</option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Photo 1</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo1")}
                  // required={true}
                />
              </div>
              <img
                src={
                  photo1 === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo1}`
                }
                height="100"
              />
              <div class="form-group">
                <label for="exampleInputPriority4">Photo 2</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo2")}
                />
              </div>
              <img
                src={
                  photo2 === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo2}`
                }
                height="100"
              />
              <div class="form-group">
                <label for="exampleInputPriority4">Photo 3</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo3")}
                />
              </div>
              <img
                src={
                  photo3 === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo3}`
                }
                height="100"
              />{" "}
              <div class="form-group">
                <label for="exampleInputName">Brand</label>
                <select
                  className="form-control"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                  required
                >
                  <option value="">Select Brand</option>
                  {brandList?.map((b) => (
                    <option key={b._id} value={b._id}>
                      {b.brandName}
                    </option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Price</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Price"
                  value={price}
                  required={true}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Product Type </label>
                <select
                  className="form-control"
                  value={productType}
                  onChange={(e) => setProductType(e.target.value)}
                >
                  <option disabled>Select Product Type</option>

                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Offer Price</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Offer Price"
                  value={offerPrice}
                  onChange={(e) => setOfferPrice(e.target.value)}
                />
              </div>
              <hr />
              {stockDiv}
              <div class="d-flex">
                <div class="p-2"> </div>
                <div class="p-2"> </div>
                <div class="ml-auto p-2 pointer" onClick={addStock}>
                  + Add more
                </div>
              </div>
              {/* <div class="alert alert-danger" role="alert">
                {prodCreateError}
              </div> */}
              {loader ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                <div className="bottom-area">
                  <p className="mt-14"></p>
                  <button type="submit" class="btn btn-primary mr-2">
                    Submit
                  </button>
                  <Link to="/products">
                    <button class="btn btn-light">Cancel</button>
                  </Link>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProduct;
